/**
 * Helper function to determine status color based on value and thresholds
 * @param {number} value - The value to check against thresholds
 * @param {Object} thresholds - Threshold values for color determination
 * @param {number} thresholds.high - High threshold (green if value >= high)
 * @param {number} thresholds.medium - Medium threshold (yellow if value >= medium, red otherwise)
 * @returns {string} - Color name ('green', 'yellow', or 'red')
 */
function getValueStatusColor(value, thresholds = { high: 100, medium: 95 }) {
  if (value >= thresholds.high) return 'green';
  if (value >= thresholds.medium) return 'yellow';
  if (!value) return 'transparent';
  return 'red';
}

/**
 * Determines color based on pengurang value
 * @param {number} nilai - The pengurang value
 * @returns {string} - Color name ('red' if negative, 'green' otherwise)
 */
function getPengurangColor(nilai) {
  if (nilai < 0) return 'red';
  return 'green';
}

/**
 * Computes style flags (colors) for KPI items based on their type and values
 * @param {Object} item - The KPI item
 * @param {boolean} isPengurang - Whether the item is a pengurang type
 * @param {boolean} isNKO - Whether the item is an NKO type
 * @returns {Object} - Object containing keterangan and vketerangan color values
 */
export function getStyleFlags(item, isPengurang, isNKO) {
  let keterangan = 'transparent';
  let vketerangan = 'transparent';

  // Set status indicator based on KPI type
  if (!item.is_parent && !isPengurang) {
    keterangan = getValueStatusColor(item.pencapaian);
  }

  if (!item.is_parent && isPengurang) {
    keterangan = getPengurangColor(item.nilai);
  }

  // Special handling for NKO items - set status indicators based on available values
  if (isNKO) {
    // Set both status indicators in one block with null coalescing
    keterangan = getValueStatusColor(item.nilai);
    vketerangan = getValueStatusColor(item.vnilai);
  }

  // Set verification status indicator based on KPI type (if not already set by NKO handling)
  if (!isNKO && !item.is_parent && isPengurang) {
    vketerangan = getPengurangColor(item.vnilai);
  } else if (!isNKO && !item.is_parent && !isPengurang) {
    vketerangan = getValueStatusColor(item.vpencapaian);
  }

  return {
    keterangan,
    vketerangan,
  };
}
